import {Deserializable} from "./deserializable.model";

export class TipoProducto_Respuesta implements Deserializable {
    DatosResult?: DatosResult_TipoProducto;
    Mensajes: Mensaje[];

    deserialize(input: any): this {
      Object.assign(this, input);
      return this;
    }
}

export class TipoProducto implements Deserializable {
  Id: string;
  Nombre: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class DatosResult_TipoProducto implements Deserializable {
  DatosListas: TipoProducto[];
  ListadoTiposProductos: any;

    deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class Mensaje implements Deserializable {
  CodigoMensaje: string;
  DescripcionMensaje: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

